import Box from '@mui/material/Box';
import List from '@mui/material/List';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { getUserData, loginUserWithEmail } from 'APIs/AuthApi';
import { initializeTorus, torus } from 'APIs/utils';
import { useAppDispatch } from 'app/hooks';
import { MenuButton, NormalButton } from 'components/atoms/Button';
import { wikiLink } from 'config/constants';
import { ACCESS_TOKEN } from 'constant';
import { MainPageContext } from 'context';
import { login, selectAuth } from 'features/auth/authSlice';
import { TorusData } from 'interfaces/torus.interface';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

interface IHamburgerMenuProps {
  children: JSX.Element;
  authenticated?: boolean;
  handleSignIn?: (torusData: TorusData) => void;
}

const HamburgerMenu = ({
  children,
  authenticated,
  handleSignIn,
}: IHamburgerMenuProps) => {
  const [open, setOpen] = React.useState(false);
  const { mainPage, setMainPage } = React.useContext(MainPageContext);
  const dispatch = useAppDispatch();
  const authState = useSelector(selectAuth);
  const history = useNavigate();
  const location = useLocation();
  const creatorToken = location.search.split('token=')[1]?.split('&&')[0];

  const toggleDrawer =
    (anchor: any, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
      setOpen(open);
    };

  const isClickedHome = (): void => {
    history('/home');
    setMainPage('home');
  };

  const isClickedCreate = (): void => {
    history('/create/nft');
    setMainPage('create');
  };

  const isClickedSign = (): void => {
    history(`/profile/${authState.username}`);
    setMainPage('signin');
  };

  const isClickedBackstage = (): void => {
    history(`/home/backstage`);
    setMainPage('backstage');
  };

  const isClickedExplore = (): void => {
    history(`/explore/nft`);
    setMainPage('explore/nft');
  };

  const onClickLogin = async (e: Event) => {
    e.preventDefault();
    try {
      if (!torus.isInitialized) {
        await initializeTorus();
      }
      const torusLogin = await torus.login();
      console.log(torusLogin[0], ' == login ==');
      const userData = await torus.getUserInfo('g');
      console.log(userData, ' == userData ==');

      try {
        const res = await loginUserWithEmail(
          userData.email,
          torusLogin[0],
          window.location.origin,
          creatorToken
        );
        if (res.data.access_token) {
          localStorage.setItem(ACCESS_TOKEN, res.data.access_token);
          const userDataRes = await getUserData();

          if (userDataRes) {
            dispatch(login({ ...userDataRes }));
          }
        }
      } catch (err) {
        const error = err as any;
        console.log('err', err);
        if (error?.response.status === 403 && handleSignIn) {
          const torusData: TorusData = {
            ...userData,
            torusWalletId: torusLogin[0],
          };
          handleSignIn(torusData);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const isClickedSetting = (): void => {
    history(`/setting`);
    setMainPage('setting');
  };

  const list = (anchor: any) => (
    <Box
      sx={{
        width: '120px',
        background: '#292739',
        height: '100%',
        paddingY: '20px',
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      {authenticated ? (
        <List
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '20px',
          }}
        >
          <div onClick={() => isClickedHome()}>
            <MenuButton
              text={'Home'}
              type={'home'}
              isPressed={mainPage === 'home'}
            />
          </div>
          <div onClick={() => window.open(wikiLink)}>
            <MenuButton
              text={'Wiki'}
              type={'wiki'}
              isPressed={mainPage === 'wiki'}
            />
          </div>

          {authState.isCreator && (
            <div onClick={() => isClickedCreate()}>
              <MenuButton
                text={'Create'}
                type={'create'}
                isPressed={mainPage === 'create'}
              />
            </div>
          )}
          <div onClick={() => isClickedSign()}>
            <MenuButton
              text={'Profile'}
              type={'user'}
              isPressed={mainPage === 'signin'}
            />
          </div>

          <div onClick={() => isClickedBackstage()}>
            <MenuButton
              text={'Backstage'}
              type={'fund'}
              isPressed={mainPage === 'backstage'}
            />
          </div>
          <div onClick={() => isClickedExplore()}>
            <MenuButton
              text={'Explore'}
              type={'create'}
              isPressed={mainPage === 'explore'}
            />
          </div>
          <div onClick={() => isClickedSetting()}>
            <MenuButton
              text={'Setting'}
              type={'setting'}
              isPressed={mainPage === 'setting'}
            />
          </div>
        </List>
      ) : (
        <List
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '20px',
          }}
        >
          <div>
            <div onClick={() => isClickedExplore()}>
              <MenuButton
                text={'Explore'}
                type={'create'}
                isPressed={mainPage === 'explore'}
              />
            </div>
            <div onClick={() => window.open(wikiLink)}>
              <MenuButton
                text={'Wiki'}
                type={'wiki'}
                isPressed={mainPage === 'wiki'}
              />
            </div>

            <NormalButton
              color="yellow"
              // onClick={() => setOpenSignInModal && setOpenSignInModal(true)}
              onClick={onClickLogin}
            >
              Sign In
            </NormalButton>
          </div>
        </List>
      )}
    </Box>
  );

  return (
    <div>
      <React.Fragment>
        <span onClick={toggleDrawer('right', true)}>{children}</span>
        <SwipeableDrawer
          anchor={'right'}
          open={open}
          onClose={toggleDrawer('right', false)}
          onOpen={toggleDrawer('right', true)}
        >
          {list('right')}
        </SwipeableDrawer>
      </React.Fragment>
    </div>
  );
};

export default HamburgerMenu;
